import { Moment } from 'moment';
import { PaymentReceivedDateSearchOption } from './payment-received-date-search-option';

export class PaymentReceivedDateSearchRule {

    constructor(
        public on: Moment | null,
        public from: Moment | null,
        public to: Moment | null,
        public option: PaymentReceivedDateSearchOption
    ){}
}
